<template>
    <v-card elevation="0" light>
        <div v-if="academy.image" class="text-center">
            <v-avatar>
                <ImageDisplay :src="academy.image" />
            </v-avatar>
        </div>
        <div class="mt-2 text-h6">
            {{ academy.name }}
        </div>
        <div class="text-center mb-2">{{ academy.cityDisplay }}</div>
        <v-card-actions v-if="!hideButton">
            <v-btn outlined block elevation="0" small color="secondary" @click="goToAcademy()">
                {{ $t('message.see_page') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

export default {
    props: [
        'academy',
        'hideButton'
    ],
    data() {
        return {
        }
    },
    components: {
    },
    methods: {
        goToAcademy() {
            this.navigateTo({ name: 'viewacademy', params: { academyId: this.academy._id } })
        }
    }
}
</script>

<style scoped></style>